import moment from 'moment'

export function generateLinkArray (options = null) {
  if (!options) return

  const today = moment()
  const todayAsDay = today.day()
  const targetWeekendStart =
    todayAsDay >= 5 && todayAsDay <= 7
      ? `${today.day(12).format('YYYYMMDD')}-12:00`
      : `${today.day(5).format('YYYYMMDD')}-12:00`
  const targetWeekendEnd =
    todayAsDay >= 5 && todayAsDay <= 7
      ? `${today.day(14).format('YYYYMMDD')}-12:00`
      : `${today.day(7).format('YYYYMMDD')}-12:00`

  const {
    driveSearchPath = '/drive/search/r',
    driveSearchWeekendStart = targetWeekendStart,
    driveSearchWeekendEnd = targetWeekendEnd,
    driveSearchCity = '',
    airSearchPath = '/m/flights',
    airSearchCityAirport = '',
    routeLocationObject = {}
  } = options

  const staySearchHref = options.hotelSEOhref

  const driveSearchHref = `${driveSearchPath}/${driveSearchCity}/${encodeURIComponent(
    driveSearchCity
  )}/${driveSearchWeekendStart}/${driveSearchWeekendEnd}/retail`

  const airSearchHref = `${airSearchPath}/${airSearchCityAirport}`
  const queryStringParams = routeLocationObject.search || ''

  return [
    {
      linkTitle: 'Hotels',
      href: `${staySearchHref}`,
      target: '_blank',
      gaCategory: 'PCLN_HOME',
      gaAction: 'Popular_HTL_Destinations',
      gaLabel: `${driveSearchCity} | Hotels Link`
    },
    {
      linkTitle: 'Cars',
      href: `${driveSearchHref}${queryStringParams}`,
      target: '_blank',
      gaCategory: 'PCLN_HOME',
      gaAction: 'Popular_HTL_Destinations',
      gaLabel: `${driveSearchCity} | Cars Link`
    },
    {
      linkTitle: 'Flights',
      href: `${airSearchHref}${queryStringParams}`,
      target: '_blank',
      gaCategory: 'PCLN_HOME',
      gaAction: 'Popular_HTL_Destinations',
      gaLabel: `${driveSearchCity} | Flights Link`
    }
  ]
}
